export default "__VITE_ASSET__JDKR7X$X__"